<div class="container">

  <app-header-dialog [iconName]="'noise_control_off'">
    Notícia
  </app-header-dialog>

  <div *ngIf="entityForm">

    <mat-tab-group>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>settings_display</mat-icon>
          <div>Capa</div>
        </ng-template>

        <div class="content">


          <div style="margin-top: 10px; margin-left: 20px;">
            <input type="file" #fileImage (change)="onFileSelected($event)" accept="image/*, application/pdf"
              style="display:none;">
            <a mat-raised-button (click)='fileImage.click()' matTooltip='Selecionar arquivo'
              style='background-color: whitesmoke;'>
              <mat-icon class='icon-add'>image_search</mat-icon>
              Selecionar imagem
            </a>
            <span style="margin: 0 20px 0 40px;" *ngIf="selectedFileName">{{selectedFileName}}</span>
          </div>

          <div style="display: flex; justify-content: center; width: 100%; margin: 20px;">
            <img [src]="storedImage" style="width: 300px; height: 300px;" *ngIf="storedImage">
          </div>

          <div>
            <mat-form-field style='width: 190px; margin-left: 20px;' appearance="outline">
              <mat-label>Data Entrada</mat-label>
              <input matInput [matDatepicker]="pickerIn" [errorStateMatcher]="matcher"
                [formControl]="entityForm.controls.dateIn">
              <mat-datepicker-toggle matSuffix [for]="pickerIn"></mat-datepicker-toggle>
              <mat-datepicker #pickerIn></mat-datepicker>
            </mat-form-field>

            <mat-form-field style='width: 190px; margin-left: 20px;' appearance="outline">
              <mat-label>Data Saída</mat-label>
              <input matInput [matDatepicker]="pickerOut" [errorStateMatcher]="matcher"
                [formControl]="entityForm.controls.dateOut">
              <mat-datepicker-toggle matSuffix [for]="pickerOut"></mat-datepicker-toggle>
              <mat-datepicker #pickerOut></mat-datepicker>
            </mat-form-field>

            <mat-form-field style='width: 190px; margin-left: 20px;' appearance="outline">
              <mat-label>Data Notícia</mat-label>
              <input matInput [matDatepicker]="picker" [errorStateMatcher]="matcher"
                [formControl]="entityForm.controls.date">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

          </div>

          <mat-form-field style='width: 900px;' appearance="outline">
            <mat-label>Título</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.title"
              autocomplete="off">
          </mat-form-field>

          <mat-form-field style='width: 900px;' appearance="outline">
            <mat-label>Texto</mat-label>
            <textarea style="height: 160px;" matInput [errorStateMatcher]="matcher"
              [formControl]="entityForm.controls.text" autocomplete="off">
              </textarea>
          </mat-form-field>

        </div>

      </mat-tab>

      <mat-tab *ngIf="isEdit">
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>settings</mat-icon>
          <div>Contexto</div>
        </ng-template>

        <div class="content">

          <mat-form-field style='width: 100%;' appearance="outline">
            <textarea style="height: calc(100vh - 270px);" matInput [errorStateMatcher]="matcher"
              [formControl]="entityForm.controls.context" autocomplete="off">
              </textarea>
          </mat-form-field>

        </div>

      </mat-tab>

      <mat-tab *ngIf="isEdit">
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>question_answer</mat-icon>
          <div>Prompt</div>
        </ng-template>

        <div class="content">

          <mat-form-field style='width: 100%;' appearance="outline">
            <textarea style="height: calc(100vh - 270px);" matInput [errorStateMatcher]="matcher"
              [formControl]="entityForm.controls.prompt" autocomplete="off">
              </textarea>
          </mat-form-field>

        </div>

      </mat-tab>

      <mat-tab *ngIf="isEdit">
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>preview</mat-icon>
          <div>Preview</div>
        </ng-template>

        <div class="content">

          <mat-form-field style='width: 100%;' appearance="outline">
            <textarea style="height: calc(100vh - 270px);" matInput [errorStateMatcher]="matcher"
              [formControl]="entityForm.controls.preview" autocomplete="off">
              </textarea>
          </mat-form-field>

        </div>

      </mat-tab>

      <mat-tab *ngIf="isEdit">
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>open_in_browser</mat-icon>
          <div>HTML</div>
        </ng-template>

        <div class="content">

          <mat-form-field style='width: 100%;' appearance="outline">
            <textarea style="height: calc(100vh - 270px);" matInput [errorStateMatcher]="matcher"
              [formControl]="entityForm.controls.html" autocomplete="off">
              </textarea>
          </mat-form-field>

        </div>

      </mat-tab>

      <mat-tab *ngIf="isEdit">
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>manage_search</mat-icon>
          <div>Arquivos</div>
        </ng-template>

        <div class="content">
          <app-file-manager [image_path]="image_path">
          </app-file-manager>
        </div>

      </mat-tab>

    </mat-tab-group>

    <div class="actions">

      <button matTooltip='Publicar' mat-raised-button (click)='publishContent()'>
        <mat-icon>publish</mat-icon>
      </button>

      <div>

        <button matTooltip='Gemini' mat-raised-button (click)='generateGeminiContent()'>
          <mat-icon class='icon-ia'>lightbulb_outlin</mat-icon>
        </button>

        <button matTooltip='Prévia' mat-raised-button (click)='previewContent()'>
          <mat-icon class='icon-add'>preview</mat-icon>
        </button>

        <button matTooltip='Salvar' mat-raised-button (click)='update()'>
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>

        <button *ngIf="!isEdit" matTooltip='Salvar' mat-raised-button
          (click)="matDialogRef.close(['insert', entityForm, selectedFile])" [disabled]="entityForm.invalid">
          <mat-icon class='icon-done'>check_circle</mat-icon>
        </button>
        <button *ngIf="isEdit" matTooltip='Salvar & Fechar' mat-raised-button
          (click)="matDialogRef.close(['update', entityForm, selectedFile])" [disabled]="entityForm.invalid">
          <mat-icon class='icon-done'>check_circle</mat-icon>
        </button>

      </div>

    </div>

  </div>

</div>